
class IntegratorMappingTargetCell extends UITableViewCell
{
    private targetLabel: MUILabel = null;
    private userInfoLabel: MUILabel = null;

    awakeFromHTML() {
        this.targetLabel = MUIOutlet(this, "target-lbl", "MUILabel");
        this.userInfoLabel = MUIOutlet(this, "user-info-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(item: IntegratorMappingTargetEntity) {
        this.targetLabel.text = item.targetEntityName + " · " + item.targetID;

        let info = item.targetUserInfo;
        let text = "";
        if (info != null) {
            try { text = JSON.stringify(info); }
            catch (e) { text = "" + info; }
        }
        this.userInfoLabel.text = text;
        this.userInfoLabel.layer.title = text;
    }
}
